var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScalable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 105,
    viewBox: "0 0 90 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.2133 76.535V99.9351C88.2133 102.599 86.0533 104.759 83.3893 104.759H59.9893C63.3023 93.743 77.9893 80.423 88.2133 76.535Z",
    fill: "url(#paint0_linear_1_3307)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24612 86.039C2.24612 80.567 11.8221 73.871 21.5421 71.207C41.7021 65.519 72.4461 63.575 88.2131 29.879V69.263C64.9571 72.575 51.6371 90.863 50.0531 104.759H7.06912C4.40512 104.759 2.24512 102.599 2.24512 99.9351C2.24612 95.3271 2.24612 90.719 2.24612 86.039Z",
    fill: "url(#paint1_linear_1_3307)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.230499 66.671C0.230499 61.127 9.3025 51.839 19.4545 49.319C38.8945 44.495 63.5905 38.519 79.2855 12.095C79.4295 11.807 79.5015 11.519 79.3575 11.231C79.2855 10.943 78.9975 10.727 78.7095 10.655L76.9815 10.151C76.6935 10.079 76.4055 9.79102 76.3335 9.43102C76.2615 9.14302 76.3335 8.78304 76.6215 8.49504L85.5495 0.142991C85.6935 0.0709907 85.8375 -0.000969701 85.9815 0.0710303C86.1975 0.0710303 86.2695 0.215016 86.3415 0.431016L89.0055 12.095C89.1495 12.455 89.0055 12.815 88.7895 13.031C88.5015 13.247 88.1415 13.391 87.8535 13.247L85.7655 12.671C85.3335 12.527 84.8295 12.743 84.6135 13.175C69.3495 47.303 40.2615 53.639 19.4545 59.327C9.3745 62.063 0.230499 71.135 0.230499 76.679V66.671Z",
    fill: "url(#paint2_linear_1_3307)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3905 0C26.0785 0 30.9025 3.88804 32.3425 9.14404C33.7105 8.20804 35.4385 7.63202 37.3105 7.63202C42.3505 7.63202 46.3825 11.664 46.3825 16.704C46.3825 17.136 46.3105 17.568 46.3105 18C49.0465 19.224 51.2065 20.88 52.7185 22.248C53.3665 22.824 53.5825 23.688 53.2945 24.408C52.9345 25.2 52.2865 25.704 51.4225 25.704C34.9345 25.704 18.4465 25.704 1.9585 25.704C1.2385 25.704 0.590507 25.272 0.230507 24.624C-0.129493 23.976 -0.0575107 23.256 0.374489 22.608C2.03049 20.232 4.7665 17.208 8.5825 16.056C8.2225 14.904 8.00651 13.68 8.00651 12.384C8.00651 5.54403 13.5505 0 20.3905 0Z",
    fill: "url(#paint3_linear_1_3307)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3307",
    x1: 66.0571,
    y1: 109.327,
    x2: 92.9967,
    y2: 81.1467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#ED638A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37197"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_3307",
    x1: 9.7529,
    y1: 108.728,
    x2: 91.8912,
    y2: 33.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#ED638A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37197"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_3307",
    x1: 4.12292,
    y1: 76.5047,
    x2: 89.0448,
    y2: 0.00474445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#ED638A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37197"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_3307",
    x1: 3.73074,
    y1: 28.3862,
    x2: 54.773,
    y2: 2.76151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#ED638A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37197"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalable);
export default __webpack_public_path__ + "static/media/scalable.bcbd6fe44cf4b4df0815d4ce4282050c.svg";
export { ForwardRef as ReactComponent };